import React from 'react'
import { useAuth } from '../hooks/useAuth'
import { Link } from 'react-router-dom'

export const Dashboard: React.FC = () => {
  const { user } = useAuth()

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">
              Welcome back, {user?.firstName}!
            </h1>
            <p className="mt-2 text-gray-600">
              {user?.companyName && `${user.companyName} • `}
              {user?.role}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Quick Actions */}
            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Quick Actions</h3>
                <div className="space-y-3">
                  <Link
                    to="/jobs"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
                  >
                    View All Jobs
                  </Link>
                  
                  {(user?.role === 'Admin' || user?.role === 'ProjectManager') && (
                    <Link
                      to="/jobs/create"
                      className="block w-full text-left px-4 py-2 text-sm text-primary-600 hover:bg-primary-50 rounded-md transition-colors"
                    >
                      Create New Job
                    </Link>
                  )}
                  
                  <Link
                    to="/profile"
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
                  >
                    Edit Profile
                  </Link>
                </div>
              </div>
            </div>

            {/* Job Status Overview */}
            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Job Overview</h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Active Jobs</span>
                    <span className="text-2xl font-bold text-green-600">-</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Pending Jobs</span>
                    <span className="text-2xl font-bold text-yellow-600">-</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Completed Jobs</span>
                    <span className="text-2xl font-bold text-blue-600">-</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Recent Activity */}
            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Recent Activity</h3>
                <div className="text-sm text-gray-500">
                  <p>No recent activity to display.</p>
                  <p className="mt-2">Start by viewing or creating jobs!</p>
                </div>
              </div>
            </div>
          </div>

          {/* Getting Started */}
          <div className="mt-8 bg-primary-50 border border-primary-200 rounded-lg p-6">
            <h3 className="text-lg font-medium text-primary-900 mb-2">
              Getting Started with ContractorPro.ai
            </h3>
            <p className="text-primary-700 mb-4">
              Welcome to your contractor management platform! Here's what you can do:
            </p>
            <ul className="list-disc list-inside text-primary-700 space-y-1">
              <li>View and manage construction jobs</li>
              <li>Track worker hours and time entries</li>
              <li>Manage expenses and invoices</li>
              <li>Upload job site photos and documents</li>
              <li>Monitor project progress and budgets</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}